import {
  pathogenicColor,
  likelyPathogenicColor,
  uncertainSignificanceColor,
  benignColor,
} from "../../../../common/helpers/colors";

export const tierColors = {
  1: pathogenicColor,
  2: likelyPathogenicColor,
  3: uncertainSignificanceColor,
  4: benignColor,
};

export const tableHeaders = [
  { id: "tier", title: "Tier" },
  { id: "somatic", title: "Somatic" },
  { id: "germline", title: "Germline" },
  { id: "somatic_tumours", title: "Tumor Types (Somatic)" },
  { id: "germline_tumours", title: "Tumor Types (Germline)" },
  { id: "cancer_syndrome", title: "Cancer Syndrome" },
  { id: "tissue_type", title: "Tissue Type" },
  { id: "molecular_genetics", title: "Molecular Genetics" },
  { id: "role_in_cancer", title: "Role in Cancer" },
  { id: "mutation_types", title: "Mutation Types" },
  { id: "translocation_partner", title: "Translocation Partner" },
  { id: "other_syndrome", title: "Other Syndrome" },
];

export const hallmarkTableHeaders = [
  { id: "title", title: "", style: { textALign: "center", width: "15%" } },
  {
    id: "cell_type",
    title: "Cell Type",
    style: { textALign: "center", width: "15%" },
  },
  {
    id: "description",
    title: "Description",
    style: { textALign: "center", width: "40%" },
  },
  {
    id: "impact",
    title: "Impact",
    style: { textALign: "center", width: "15%" },
  },
  {
    id: "pub_med_references",
    title: "Publications",
    style: { textALign: "center", width: "15%" },
  },
];
